import { baseCellStyles } from '../cells.consts';
import { ITableStickyColumn } from '../../table.interfaces';
import { MuiTableCell, styled } from '../../../base-components';
import { shouldForwardProp } from '@mui/system';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    !['stickyColumn', 'rowStickyWidths', 'columnIndex', 'isSelected'].includes(
        prop as string
    );

export const StyledTableCell = styled(MuiTableCell, {
    shouldForwardProp: customShouldForwardProp,
})<{
    alignment: string;
    stickyColumn?: ITableStickyColumn;
    rowStickyWidths?: Array<number>;
    columnIndex?: number;
    isSelected?: boolean;
}>(({
    theme,
    alignment: alignment,
    stickyColumn: stickyColumn,
    rowStickyWidths: rowStickyWidths,
    columnIndex: columnIndex,
    isSelected: isSelected,
}) => {
    const baseStyles = baseCellStyles(
        theme,
        alignment,
        stickyColumn,
        rowStickyWidths,
        columnIndex,
        isSelected
    );
    return {
        ...baseStyles,
    };
});
